import { createI18n } from "vue-i18n";
import pl from "./lang/pl";
//@ts-ignore
import { ref, watch } from "vue";
import storeCache from "../js/storeCache";
import de from "./lang/de";
import en from "./lang/en";

const messages = {
  pl,
  en,
  de
};

const availableLang = ["pl", "en", 'de'];

export let currentLang = ref(storeCache.get("lang") || "pl");

const cache = storeCache;

export function getLangConfig() {
  if (!availableLang.includes(currentLang.value)) {
    currentLang.value = "pl";
  }
  
  watch(currentLang, (newLang) => {
    cache.set("lang", newLang);
  }, { immediate: true });

  return currentLang.value;
}

export function setLangConfig(language: string) {
  if (availableLang.includes(language)) {
    cache.set("lang", language);
    currentLang.value = language;
    
    if (i18n.global.locale) {
      i18n.global.locale.value = language;
    }
  }
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getLangConfig(),
  fallbackLocale: "pl",
  formatFallbackMessages: true,
  messages: messages,
});

watch(currentLang, (newLang) => {
  //@ts-ignore
  if (i18n.global.locale && i18n.global.locale.value !== newLang) {
  //@ts-ignore
    i18n.global.locale.value = newLang;
  }
});

export default i18n;